import React from 'react';

import { BaseExportDialog } from '../../../SimulationExportDialog/components/BaseExportDialog';
import { useExportCheckboxes } from '../../../SimulationExportDialog/hooks/useExportCheckboxes';

interface ExportDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedRequest: any;
  operationDetails: any;
}

const ExportDialog = (props: ExportDialogProps) => {
  const { open, setOpen, selectedRequest, operationDetails } = props;

  function canShowPayoutsForStatus(status: string): boolean {
    return status === 'Activa' || status === 'Completada';
  }
  const canShowPayouts = canShowPayoutsForStatus(selectedRequest.status);

  const [checkboxes, setters] = useExportCheckboxes({
    includePayouts: true,
    includeRateComposition: false,
  });

  return (
    <BaseExportDialog
      open={open}
      setOpen={setOpen}
      selectedRequest={selectedRequest}
      operationDetails={operationDetails}
      checkboxes={checkboxes}
      setters={setters}
      exportOptions={{
        includePayouts: true,
        canShowPayouts,
      }}
      includeRateComposition={false}
    />
  );
};

export default ExportDialog;
